module.exports = __webpack_public_path__ + "img/step2.0b6454be.svg";